import React, {useState} from 'react';
import _ from 'lodash';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import {Slot} from './SlotGroup';

const UpdateSlot = ({data, setPath, onUpdateSlot}) => {

  const adjustValue = data => ({...data, value: data.value / 100})
  const [slotData, _setSlotData] = useState(adjustValue(_.cloneDeep(data)));

  const handleChange = event => {
    event.persist && event.persist();

    _setSlotData(prevState => {
      const {name, value} = event.target;
      return _.set(_.cloneDeep(prevState), [name], value);
    });
  };

  const onSubmit = () => onUpdateSlot(slotData);

  return <Grid container justify='space-around' align='center'>
    <Grid item xs={12}>
      <Slot {...slotData} {...{handleChange}}/>
    </Grid>
    <Grid item>
      <Button color="primary" onClick={onSubmit}>
        Enviar
      </Button>
    </Grid>
    <Grid item>
      <Button color="primary" onClick={() => setPath('detail')}>
        Voltar
      </Button>
    </Grid>
  </Grid>;
};

export default UpdateSlot;
